<script>
import FormSection from '@/components/FormSection'

export default {
  section: {
    query: null,
    mutation: () => {},
    model: {},
    saveModel: () => {},
  },

  components: {
    FormSection,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      initialModelData: {},
      modelData: {},
      loading: true,
      skipDirtyCheck: false,
      validationObservers: [],
      autosaveTimeout: null,
      skipAutoSave: false,
    }
  },

  computed: {
    dirty() {
      return this.$store.state.podcast.dirty
    },
    updateLoading() {
      return this.$store.state.podcast.updateLoading
    },
  },

  watch: {
    dirty(isDirty) {
      if (isDirty) {
        window.onbeforeunload = () => 'Prevent exit'
      } else {
        window.onbeforeunload = undefined
      }
    },
    modelData: {
      deep: true,
      handler(newValue) {
        if (!this.skipDirtyCheck) {
          let dirty = false

          Object.keys(newValue).forEach(key => {
            const currentValue = newValue[key] === '' ? null : newValue[key]
            const oldValue =
              this.initialModelData[key] === ''
                ? null
                : this.initialModelData[key]

            if (currentValue !== oldValue) {
              dirty = true
            }
          })

          if (dirty) {
            this.markAsDirty()
            this.autosave()
          } else {
            clearTimeout(this.autosaveTimeout)
            this.markAsClean()
          }
        }
      },
    },
  },

  async created() {
    if (this.$options.section.query) {
      try {
        const res = await this.$apollo.query(
          this.$options.section.query.call(this),
        )
        if (res && res.data) {
          this.initializeData(res.data)
        } else {
          console.log(res)
        }
      } catch (err) {
        console.log(err)
      }
    }

    this.loading = false

    this.$store.commit('podcast/setSubmitCallback', this.submit.bind(this))

    this.$store.commit('podcast/setUpdateCallback', this.afterUpdate)
  },

  methods: {
    markAsDirty() {
      this.$store.commit('podcast/setDirty', true)
    },
    markAsClean() {
      this.$store.commit('podcast/setDirty', false)
    },
    initializeData(data) {
      this.skipDirtyCheck = true
      const modelIsFunction = typeof this.$options.section.model === 'function'
      const model = this.$options.section.model

      this.$set(this, 'modelData', {
        ...(modelIsFunction ? model.call(this) : model),
        ...this.sanitizeModelData(data),
      })
      this.$set(this, 'initialModelData', {
        ...(modelIsFunction ? model.call(this) : model),
        ...this.sanitizeModelData(data),
      })

      this.$nextTick(() => {
        this.skipDirtyCheck = false
      })
    },
    afterUpdate(err) {
      if (err) {
        console.dir(err)
      } else {
        this.initialModelData = { ...this.modelData }
        this.markAsClean()
      }
    },
    sanitizeModelData(data) {
      const savedData = this.$options.section.saveModel.call(this, data)
      delete savedData['__typename']

      return savedData
    },
    submit() {
      return this.$options.section.mutation.call(this)
    },
    validateAndSubmit(silent = false) {
      this.validationObservers = []
      this.findValidationObservers(this.$children)

      return Promise.all(
        this.validationObservers.map(observer => observer.validate({ silent })),
      ).then(results => {
        const valid = results.reduce(
          (result, currentValue) => result && currentValue,
          true,
        )

        if (valid) {
          this.$store.dispatch('podcast/update')
        }

        return valid
      })
    },
    findValidationObservers(children = []) {
      if (!children.length) {
        return
      }

      children.forEach(child => {
        if (child.$options.name === 'ValidationObserver') {
          this.validationObservers.push(child)
        } else {
          this.findValidationObservers(child.$children)
        }
      })
    },
    autosave() {
      if (this.skipAutoSave) {
        return
      }

      if (this.autosaveTimeout) {
        clearTimeout(this.autosaveTimeout)
      }

      this.autosaveTimeout = setTimeout(() => {
        if (!this.skipAutoSave) {
          this.validateAndSubmit(true)
        }

        this.autosaveTimeout = null
      }, 500)
    },
  },
}
</script>
